import {TextArea} from '../../designComponents/inputs/TextArea';
import React from 'react';

const UserIdInputTable = ({ setSendUser, isPhone }) => {
    const onChangeIdList = (text) => {
        if (isPhone) {
            setSendUser(text.split('\n').filter((e) => e.length > 0));
        } else {
            setSendUser(
                text
                    .split('\n')
                    .filter((e) => e.length > 0)
                    .map((e) => Number(e)),
            );
        }
    };
    return (
        <div>
            <TextArea
                style={{ width: '100%', marginBottom: '5px' }}
                placeholder={`${isPhone ? '전화번호' : 'ID'}를 입력해 주세요 Enter으로 구분합니다.`}
                onChange={(e) => {
                    onChangeIdList(e.target.value.replaceAll('-', ''));
                }}
            />
        </div>
    );
};

export default UserIdInputTable;
